var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_vm._t("title"),_c('div',{staticStyle:{"overflow-x":"auto","width":"100%"}},[_c('div',{staticStyle:{"min-width":"300px","height":"300px","position":"relative"}},[_c('canvas',{ref:"chartCanvas"})])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }